import React, { useEffect } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import TutorSidebar from '../../../../TutorSidebar/TutorSidebar'
import { useDispatch, useSelector } from 'react-redux';
import { getTutorViewAssDetail } from '../../../../../../Redux/action/TutorAction';
import Beatloader from '../../../../../../Common/BeatLoader';

const host = process.env.REACT_APP_API_SERVER

const TutorViewAssessmentSubjectiveTest = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { b64id } = useParams();

    useEffect(() => {
        try {

            let assessment_id = atob(b64id);

            if (!assessment_id || isNaN(assessment_id)) {
                throw new Error("Invalid course ID");
            }

            dispatch(getTutorViewAssDetail(assessment_id))
        } catch (error) {

            navigate(-1);
        }
    }, [b64id]);

    const {
        loadingTutorViewAssDetailApi,
        TutorViewAssDetailApiData,
        TutorViewAssDetailApiError

    } = useSelector(state => state?.TutorReducer);



    const questionList = TutorViewAssDetailApiData?.subjective_questions?.[0]?.question_and_marks ? JSON.parse(TutorViewAssDetailApiData?.subjective_questions?.[0]?.question_and_marks) : []


    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Subjective Test
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                {loadingTutorViewAssDetailApi ?
                                    <Beatloader />
                                    :
                                    <form >
                                        <div className="row mb-3">
                                            <div className="col-lg-12">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h5 className="mb-3">Download Test</h5>
                                                        <div className="row">
                                                            <div className="col-lg-6">
                                                                <h5 className="mb-0">{TutorViewAssDetailApiData?.assesment_name}</h5>
                                                            </div>
                                                            <div className="col-lg-6 d-flex justify-content-end">
                                                                <a
                                                                    target='blank'
                                                                    href={`${host}/${TutorViewAssDetailApiData?.subjective_questions?.[0]?.file}`}
                                                                    download="seek2lrn-subjective-question"
                                                                    className="btn btn-success"
                                                                >
                                                                    Download
                                                                </a>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {questionList?.length > 0 ?
                                            questionList?.map((data, index) => (
                                                <div className="row mb-3">
                                                    <div className="col-lg-4 col-md-4 mb-3">
                                                        <div className="card bg-light">
                                                            <div className="card-body">
                                                                <h6 className="mb-2">Question : {index + 1}</h6>
                                                                <h5 className="fw-bold">{data?.question_no}</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-4 mb-3">
                                                        <div className="card">
                                                            <div className="card-body">
                                                                <h6 className="mb-2">Max. Marks</h6>
                                                                <h5 className="fw-bold">{data?.marks}</h5>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            ))
                                            :
                                            <div className='no-data-img'>
                                                <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                            </div>
                                        }


                                    </form>
                                }
                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorViewAssessmentSubjectiveTest